import { FC, useMemo } from 'react'
import Navbar from '@app/components/Navbar'
import Footer from '@app/components/Footer'
import Button from '@app/components/Button/Button'
import urls from '@app/routes/urls'
import { FormattedMessage } from 'react-intl'
import { useParams } from 'react-router-dom'
import S from './styles'

const NotFound: FC = () => {
  const params = useParams<{ program: string; campaign?: string }>()
  const programInUrl = useMemo(() => params.program, [params.program])

  return (
    <>
      {programInUrl && <Navbar />}
      <S.Main>
        <FormattedMessage id="static.page.not_found.title" tagName="h1" />
        <FormattedMessage id="static.page.not_found.description" tagName="p" />
        {programInUrl && (
          <Button to={urls.root}>
            <FormattedMessage id="static.page.not_found.button_text" />
          </Button>
        )}
      </S.Main>
      {programInUrl && <Footer />}
    </>
  )
}

export default NotFound
